import React from 'react'
import PropTypes from 'prop-types'
import classes from './index.module.css'
import Tooltip from '../Tooltip'

export default function PublicationBadge({
  text,
  status,
  size = 'sm',
  className = '',
  onClick,
  disabled = false,
  tooltip,
}) {
  return (
    <Tooltip text={tooltip}>
      <div
        className={`${classes.badge} ${classes['badge__' + status]} ${
          classes['badge__' + size]
        } ${onClick && !disabled ? classes.clickable : ''} ${
          disabled ? classes.disabled : ''
        } ${className}`.trim()}
        onClick={disabled ? undefined : onClick}
      >
        {text}
      </div>
    </Tooltip>
  )
}

PublicationBadge.propTypes = {
  status: PropTypes.oneOf(['published', 'unpublished', 'tease']).isRequired,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'header']),
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
}
